<template>
  <div>
    <div class="page-wrap">
      <h2 class="title-page fw-500">
        <i class="fas fa-book mr-2"></i>รายการฝากทศนิยม
      </h2>
      <div class="body-content">
        <p class="mt-3">สรุปรายการฝากทศนิยม</p>
        <div class="row">
          <div class="col-md-4">
            <date-picker
              class="input-date w-100"
              valueType="format"
              type="date"
              lang="en"
              v-model="payload.date"
              v-on:change="onchange"
            ></date-picker>
          </div>
        </div>
        <div class="table-content">
          <mdb-datatable
            :arrows="true"
            :data="tableData"
            striped
            bordered
            :searching="false"
            scrollY
            maxHeight="450px"
            v-if="reloading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var axios = require("axios");
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import jwt from "jsonwebtoken";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      reloading: false,
      //   dateselect1: "",
      selectbank: [],
      payload: {
        date: moment().format("YYYY-MM-DD"),
        bank_number: "",
      },
      tableData: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
          },
          {
            label: "วันที่",
            field: "datetime",
            sort: true,
          },
          {
            label: "เวลาเริ่มทำรายการ",
            field: "start_date",
            sort: true,
          },
          {
            label: "เวลาสิ้นสุดรายการ",
            field: "end_date",
            sort: true,
          },
          {
            label: "จำนวนเงิน",
            field: "amount",
            sort: true,
          },
          {
            label: "username",
            field: "username",
            sort: true,
          },
          {
            label: "สถานะ",
            field: "status",
            sort: true,
            format: (value) => {
              var StatusColor = "";
              var StatusText = "";
              if (value == 1) {
                StatusColor = "#00D717";
                StatusText = "สำเร็จ";
              } else if (value == 2) {
                StatusColor = "red";
                StatusText = "เกินระยะเวลา";
              } else {
                StatusColor = "#FFD700";
                StatusText = "ยังไม่ทำรายการ";
              }

              return `<div class="text-center btnbtn" style="max-width:110px;" data-status="${
                value === 1 ? "true" : "false"
              }">
                <label class=" text-white font14"  style="cursor: pointer;background-color:${StatusColor};border-radius:6px;">
                    <p class="mb-0" style="font-size:0.6rem;padding:2px 6px;">${StatusText}</p>
                </label>
                </div>`;
            },
          },
        ],
        rows: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      tokens: "tokens",
    }),
    data() {
      return {
        columns: [],
        rows: [],
      };
    },
  },
  async mounted() {
    this.reloading = true;
    this.getStatementByDate();
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      loadsession: "loadsession",
    }),
    async onchange() {
      this.getStatementByDate();
    },

    async getStatementByDate() {
      this.tableData.rows = null;
      this.reloading = false;
      const token = jwt.sign(this.payload, this.$keypayload);
      var config = {
        method: "POST",
        url: "https://sms-fast.warmlight.online/api/getDepositDecimal",
        headers: {
          Authorization: "Bearer " + this.tokens,
        },
        data: { token: token },
      };
      await axios(config)
        .then((response) => {
          this.$nextTick(() => {
            this.reloading = true;
          });

          this.tableData.rows = this.$add_index(response.data.payload);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style></style>
